import React from "react";
import Header from "./Header";
import Hero from "./Hero";
import Footer from "./Footer";

const Datenschutzerklarung = () => {
  return (
    <div className="KeysHome">
      <Header />
      <main className="main">
        <Hero compact />
        <section id="projects" className="projects section">
          <div className="container section-title" data-aos="fade-up">
            <h2>Datenschutzerklärung</h2>
            <br />
            <div className="legal-text">
              <p>Datenschutzerklärung</p>
              <br />
              <p>1. Datenschutz auf einen Blick</p>
              <br />
              <p>Allgemeine Hinweise</p>
              <br />
              <p>
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
                personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene
                Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
                Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem
                Text aufgeführten Datenschutzerklärung.
              </p>
              <br />
              <p>Datenerfassung auf unserer Website</p>
              <br />
              <p>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</p>
              <br />
              <p>
                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen
                Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
              </p>
              <br />
              <p>Wie erfassen wir Ihre Daten?</p>
              <br />
              <p>
                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei
                kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
              </p>
              <br />
              <p>
                Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme
                erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem
                oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch,
                sobald Sie unsere Website betreten.
              </p>
              <br />
              <p>Wofür nutzen wir Ihre Daten?</p>
              <br />
              <p>
                Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu
                gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet
                werden.
              </p>
              <br />
              <p>Welche Rechte haben Sie bezüglich Ihrer Daten?</p>
              <br />
              <p>
                Sie haben jederzeit das Recht unentgeltlich Auskunft über Herkunft, Empfänger und
                Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem
                ein Recht, die Berichtigung, Sperrung oder Löschung dieser Daten zu verlangen.
                Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit
                unter der im Impressum angegebenen Adresse an uns wenden. Des Weiteren steht Ihnen
                ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
              </p>
              <br />
              <p>
                Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der
                Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Details hierzu entnehmen
                Sie der Datenschutzerklärung unter „Recht auf Einschränkung der Verarbeitung“.
              </p>
              <br />
              <p>Analyse-Tools und Tools von Drittanbietern</p>
              <br />
              <p>
                Beim Besuch unserer Website kann Ihr Surf-Verhalten statistisch ausgewertet werden.
                Das geschieht vor allem mit Cookies und mit sogenannten Analyseprogrammen. Die
                Analyse Ihres Surf-Verhaltens erfolgt in der Regel anonym; das Surf-Verhalten kann
                nicht zu Ihnen zurückverfolgt werden. Sie können dieser Analyse widersprechen oder
                sie durch die Nichtbenutzung bestimmter Tools verhindern. Detaillierte Informationen
                dazu finden Sie in der folgenden Datenschutzerklärung.
              </p>
              <br />
              <p>
                Sie können dieser Analyse widersprechen. Über die Widerspruchsmöglichkeiten werden
                wir Sie in dieser Datenschutzerklärung informieren.
              </p>
              <br />
              <p>2. Allgemeine Hinweise und Pflichtinformationen</p>
              <br />
              <p>Datenschutz</p>
              <br />
              <p>
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst.
                Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der
                gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>
              <br />
              <p>
                Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben.
                Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden
                können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und
                wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.
              </p>
              <br />
              <p>
                Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der
                Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz
                der Daten vor dem Zugriff durch Dritte ist nicht möglich.
              </p>
              <br />
              <p>Hinweis zur verantwortlichen Stelle</p>
              <br />
              <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
              <br />
              <p>Schlüsseldienst in Kiel</p>
              <p>M. Ismail</p>
              <p>Westring 255</p>
              <p>24116 Kiel</p>
              <br />
              <p>Telefon: 0151 - 72 54 62 46</p>
              <p>E-Mail: info@schluesseldienst-in-kiel.de</p>
              <br />
              <p>
                Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder
                gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von
                personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
              </p>
              <br />
              <p>Widerruf Ihrer Einwilligung zur Datenverarbeitung</p>
              <br />
              <p>
                Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung
                möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu
                reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum
                Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
              </p>
              <br />
              <p>
                Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen
                Direktwerbung (Art. 21 DSGVO)
              </p>
              <br />
              <p>
                Wenn die Datenverarbeitung auf Grundlage von Art. 6 Abs. 1 lit. e oder f DSGVO
                erfolgt, haben Sie jederzeit das Recht, aus Gründen, die sich aus Ihrer besonderen
                Situation ergeben, gegen die Verarbeitung Ihrer personenbezogenen Daten Widerspruch
                einzulegen; dies gilt auch für ein auf diese Bestimmungen gestütztes Profiling. Die
                jeweilige Rechtsgrundlage, auf denen eine Verarbeitung beruht, entnehmen Sie dieser
                Datenschutzerklärung. Wenn Sie Widerspruch einlegen, werden wir Ihre betroffenen
                personenbezogenen Daten nicht mehr verarbeiten, es sei denn, wir können zwingende
                schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte
                und Freiheiten überwiegen oder die Verarbeitung dient der Geltendmachung, Ausübung
                oder Verteidigung von Rechtsansprüchen (Widerspruch nach Art. 21 Abs. 1 DSGVO).
              </p>
              <br />
              <p>
                Werden Ihre personenbezogenen Daten verarbeitet, um Direktwerbung zu betreiben, so
                haben Sie das Recht, jederzeit Widerspruch gegen die Verarbeitung Sie betreffender
                personenbezogener Daten zum Zwecke derartiger Werbung einzulegen; dies gilt auch für
                das Profiling, soweit es mit solcher Direktwerbung in Verbindung steht. Wenn Sie
                widersprechen, werden Ihre personenbezogenen Daten anschließend nicht mehr zum
                Zwecke der Direktwerbung verwendet (Widerspruch nach Art. 21 Abs. 2 DSGVO).
              </p>
              <br />
              <p>Beschwerderecht bei der zuständigen Aufsichtsbehörde</p>
              <br />
              <p>
                Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei
                einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen
                Aufenthalts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu. Das
                Beschwerderecht besteht unbeschadet anderweitiger verwaltungsrechtlicher oder
                gerichtlicher Rechtsbehelfe.
              </p>
              <br />
              <p>Recht auf Datenübertragbarkeit</p>
              <br />
              <p>
                Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in
                Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in
                einem gängigen, maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die
                direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt
                dies nur, soweit es technisch machbar ist.
              </p>
              <br />
              <p>SSL- bzw. TLS-Verschlüsselung</p>
              <br />
              <p>
                Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
                vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns
                als Seitenbetreiber senden, eine SSL-bzw. TLS-Verschlüsselung. Eine verschlüsselte
                Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von “http://” auf
                “https://” wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
              </p>
              <br />
              <p>
                Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an
                uns übermitteln, nicht von Dritten mitgelesen werden.
              </p>
              <br />
              <p>Auskunft, Sperrung, Löschung und Berichtigung</p>
              <br />
              <p>
                Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf
                unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren
                Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf
                Berichtigung, Sperrung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen
                zum Thema personenbezogene Daten können Sie sich jederzeit unter der im Impressum
                angegebenen Adresse an uns wenden.
              </p>
              <br />
              <p>Recht auf Einschränkung der Verarbeitung</p>
              <br />
              <p>
                Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen
                Daten zu verlangen. Hierzu können Sie sich jederzeit unter der im Impressum
                angegebenen Adresse an uns wenden. Das Recht auf Einschränkung der Verarbeitung
                besteht in folgenden Fällen:
              </p>
              <br />
              <ul>
                <li>
                  Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten
                  bestreiten, benötigen wir in der Regel Zeit, um dies zu überprüfen. Für die Dauer
                  der Prüfung haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer
                  personenbezogenen Daten zu verlangen.
                </li>
                <li>
                  Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig geschah /
                  geschieht, können Sie statt der Löschung die Einschränkung der Datenverarbeitung
                  verlangen.
                </li>
                <li>
                  Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie sie jedoch zur
                  Ausübung, Verteidigung oder Geltendmachung von Rechtsansprüchen benötigen, haben
                  Sie das Recht, statt der Löschung die Einschränkung der Verarbeitung Ihrer
                  personenbezogenen Daten zu verlangen.
                </li>
                <li>
                  Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine
                  Abwägung zwischen Ihren und unseren Interessen vorgenommen werden. Solange noch
                  nicht feststeht, wessen Interessen überwiegen, haben Sie das Recht, die
                  Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                </li>
              </ul>
              <br />
              <p>
                Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt haben, dürfen
                diese Daten – von ihrer Speicherung abgesehen – nur mit Ihrer Einwilligung oder zur
                Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen oder zum Schutz der
                Rechte einer anderen natürlichen oder juristischen Person oder aus Gründen eines
                wichtigen öffentlichen Interesses der Europäischen Union oder eines Mitgliedstaats
                verarbeitet werden.
              </p>
              <br />
              <p>3. Datenerfassung auf unserer Website</p>
              <br />
              <p>Cookies</p>
              <br />
              <p>
                Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf
                Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu,
                unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind
                kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser
                speichert.
              </p>
              <br />
              <p>
                Die meisten der von uns verwendeten Cookies sind so genannte “Session-Cookies”. Sie
                werden nach Ende Ihres Besuchs automatisch gelöscht. Andere Cookies bleiben auf
                Ihrem Endgerät gespeichert bis Sie diese löschen. Diese Cookies ermöglichen es uns,
                Ihren Browser beim nächsten Besuch wiederzuerkennen.
              </p>
              <br />
              <p>
                Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies
                informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies
                für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der
                Cookies beim Schließen des Browser aktivieren. Bei der Deaktivierung von Cookies
                kann die Funktionalität dieser Website eingeschränkt sein.
              </p>
              <br />
              <p>
                Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs oder zur
                Bereitstellung bestimmter, von Ihnen erwünschter Funktionen (z.B. Warenkorbfunktion)
                erforderlich sind, werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert.
                Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von Cookies
                zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Soweit
                andere Cookies (z.B. Cookies zur Analyse Ihres Surfverhaltens) gespeichert werden,
                werden diese in dieser Datenschutzerklärung gesondert behandelt.
              </p>
              <br />
              <p>Server-Log-Dateien</p>
              <br />
              <p>
                Der Provider der Seiten erhebt und speichert automatisch Informationen in so
                genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies
                sind:
              </p>
              <br />
              <ul>
                <li>Browsertyp und Browserversion</li>
                <li>verwendetes Betriebssystem</li>
                <li>Referrer URL</li>
                <li>Hostname des zugreifenden Rechners</li>
                <li>Uhrzeit der Serveranfrage</li>
                <li>IP-Adresse</li>
              </ul>
              <br />
              <p>
                Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.
              </p>
              <br />
              <p>
                Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der
                Websitebetreiber hat ein berechtigtes Interesse an der technisch fehlerfreien
                Darstellung und der Optimierung seiner Website – hierzu müssen die Server-Log-Files
                erfasst werden.
              </p>
              <br />
              <p>Anfrage per E-Mail, Telefon oder Telefax</p>
              <br />
              <p>
                Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage
                inklusive aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum
                Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese
                Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
              <br />
              <p>
                Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO,
                sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur
                Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen
                beruht die Verarbeitung auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) und /
                oder auf unseren berechtigten Interessen (Art. 6 Abs. 1 lit. f DSGVO), da wir ein
                berechtigtes Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen
                haben.
              </p>
              <br />
              <p>
                Die von Ihnen an uns per Kontaktanfragen übersandten Daten verbleiben bei uns, bis
                Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder
                der Zweck für die Datenspeicherung entfällt (z. B. nach abgeschlossener Bearbeitung
                Ihres Anliegens). Zwingende gesetzliche Bestimmungen – insbesondere gesetzliche
                Aufbewahrungsfristen – bleiben unberührt.
              </p>
              <br />
              <p>4. Analyse-Tools und Werbung</p>
              <br />
              <p>Google Analytics</p>
              <br />
              <p>
                Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter ist
                die Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.
              </p>
              <br />
              <p>
                Google Analytics verwendet so genannte "Cookies". Das sind Textdateien, die auf
                Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website
                durch Sie ermöglichen. Die durch den Cookie erzeugten Informationen über Ihre
                Benutzung dieser Website werden in der Regel an einen Server von Google in den USA
                übertragen und dort gespeichert.
              </p>
              <br />
              <p>
                Die Speicherung von Google-Analytics-Cookies und die Nutzung dieses Analyse-Tools
                erfolgen auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein
                berechtigtes Interesse an der Analyse des Nutzerverhaltens, um sowohl sein
                Webangebot als auch seine Werbung zu optimieren.
              </p>
              <br />
              <p>IP Anonymisierung</p>
              <br />
              <p>
                Wir haben auf dieser Website die Funktion IP-Anonymisierung aktiviert. Dadurch wird
                Ihre IP-Adresse von Google innerhalb von Mitgliedstaaten der Europäischen Union oder
                in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum vor
                der Übermittlung in die USA gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse
                an einen Server von Google in den USA übertragen und dort gekürzt. Im Auftrag des
                Betreibers dieser Website wird Google diese Informationen benutzen, um Ihre Nutzung
                der Website auszuwerten, um Reports über die Websiteaktivitäten zusammenzustellen
                und um weitere mit der Websitenutzung und der Internetnutzung verbundene
                Dienstleistungen gegenüber dem Websitebetreiber zu erbringen. Die im Rahmen von
                Google Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen
                Daten von Google zusammengeführt.
              </p>
              <br />
              <p>Browser Plugin</p>
              <br />
              <p>
                Sie können die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer
                Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem
                Fall gegebenenfalls nicht sämtliche Funktionen dieser Website vollumfänglich werden
                nutzen können. Sie können darüber hinaus die Erfassung der durch den Cookie
                erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse)
                an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem Sie das
                unter dem folgenden Link verfügbare Browser-Plugin herunterladen und installieren:
                https://tools.google.com/dlpage/gaoptout?hl=de.
              </p>
              <br />
              <p>Widerspruch gegen Datenerfassung</p>
              <br />
              <p>
                Sie können die Erfassung Ihrer Daten durch Google Analytics verhindern, indem Sie
                auf folgenden Link klicken. Es wird ein Opt-Out-Cookie gesetzt, der die Erfassung
                Ihrer Daten bei zukünftigen Besuchen dieser Website verhindert: Google Analytics
                deaktivieren.
              </p>
              <br />
              <p>
                Mehr Informationen zum Umgang mit Nutzerdaten bei Google Analytics finden Sie in der
                Datenschutzerklärung von Google:
                https://support.google.com/analytics/answer/6004245?hl=de.
              </p>
              <br />
              <p>Auftragsverarbeitung</p>
              <br />
              <p>
                Wir haben mit Google einen Vertrag zur Auftragsverarbeitung abgeschlossen und setzen
                die strengen Vorgaben der deutschen Datenschutzbehörden bei der Nutzung von Google
                Analytics vollständig um.
              </p>
              <br />
              <p>Demografische Merkmale bei Google Analytics</p>
              <br />
              <p>
                Diese Website nutzt die Funktion “demografische Merkmale” von Google Analytics.
                Dadurch können Berichte erstellt werden, die Aussagen zu Alter, Geschlecht und
                Interessen der Seitenbesucher enthalten. Diese Daten stammen aus interessenbezogener
                Werbung von Google sowie aus Besucherdaten von Drittanbietern. Diese Daten können
                keiner bestimmten Person zugeordnet werden. Sie können diese Funktion jederzeit über
                die Anzeigeneinstellungen in Ihrem Google-Konto deaktivieren oder die Erfassung
                Ihrer Daten durch Google Analytics wie im Punkt “Widerspruch gegen Datenerfassung”
                dargestellt generell untersagen.
              </p>
              <br />
              <p>5. Plugins und Tools</p>
              <br />
              <p>Google Web Fonts</p>
              <br />
              <p>
                Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Web
                Fonts, die von Google bereitgestellt werden. Die Google Fonts sind lokal
                installiert. Eine Verbindung zu Servern von Google findet dabei nicht statt.
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Datenschutzerklarung;
